// Page entry. PRD 11 §1.2:
//   - CONTENT_LIB:NO_PERMISSION → LNB still shows the menu (PRD 21 §4.5), entry
//     is blocked here with the 권한 없음 modal.
//   - READ / WRITE / Root → see the page; component-level write checks gate the
//     CRUD controls (매뉴얼 추가 / save / delete).
// Classification management was removed (PRD v1.2 / ADM.019 / ADM.020) — the
// Area/Sub-area/Item tree is read-only from PRO Item Design (PRD 04); there is
// no [분류 관리] entry point here anymore.

import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

import { useRequirePermission } from '@/shared/hooks/useRequirePermission';
import { useWriteGuard } from '@/shared/hooks/useWriteGuard';
import { CounselingManualView } from '@/features/counseling-manual/components/CounselingManualView';
import { useCounselingManualPageStore } from '@/features/counseling-manual/store/counseling-manual-page.store';

export function CounselingManualPage() {
  const { t } = useTranslation('counseling-manual');
  // SHCT-448 ⑧ established the modal-then-redirect behaviour here, in this page's own private gate.
  // SHCT-171 moved it into useRequirePermission so all 19 gated pages share it — the behaviour the
  // user sees is unchanged (PRD 21 §7.2 모달 + "접근 권한이 없습니다.", redirect on acknowledge); only its
  // home moved. The copy is now the shared common:gate.noPermission, which PRD 21 fixes verbatim.
  const canRead = useRequirePermission('CONTENT_LIB', 'READ');
  // SHCT-582 — PRD 21 §7.4 P-2: `disabled` + 툴팁 rather than a hidden action, so a Role without
  // WRITE can still see what exists and why it is refused.
  const { canWrite, denyProps } = useWriteGuard('CONTENT_LIB');
  const openCreate = useCounselingManualPageStore((s) => s.openCreate);

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('title')}</h1>
        </div>
        <div className="content__actions">
          <button
            type="button"
            className="btn btn-default btn-primary"
            onClick={openCreate}
            disabled={!canWrite}
            {...denyProps}
          >
            <Plus size={16} />
            {t('addButton')}
          </button>
        </div>
      </div>
      <div className="content__body">
        <CounselingManualView />
      </div>
    </>
  );
}
